import { useMemo } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

import { Percomatic } from '@biggby-coffee/percomatic-typescript';

import { percomaticState } from '../../../atoms';
import { Option } from '../../../components/Option';
import { normalizeLabel } from '../../../utils/normalizeLabel';
import {
	isSizeOptionActiveState,
	modifyingState,
	sizesState
} from '../../atoms';
import { useChangeSize } from '../../hooks/api';

const SIZE_TO_BE_EXCLUDE = '16oz';
const PRODUCT_IDS = [
	242, 814, 1228, 1229, 1230, 1400, 1405, 1421, 1430, 1439, 1501, 1516, 1517,
	1518, 1519, 1521, 1522, 1934, 1939, 1953, 1956, 2055, 2057, 2083, 1935,
	1936, 1937, 1938, 1939, 1940, 1954, 1957, 2056, 2058, 2084
];
const KIDS_SIZE = ["Kids'"];
const MAGIC_MILK_PRODUCT_ID = 528;
export const Size: React.FC = () => {
	const changeSize = useChangeSize();
	const modifying = useRecoilValue(modifyingState);

	const { sizes, selectedIndex } = useRecoilValue(sizesState);
	const {
		ui: {
			homeScreenHandler: {
				orderScreenHandler: { selectedItem }
			}
		}
	} = useRecoilValue(percomaticState);

	const [isSizeOptionActive, setIsSizeOptionActive] = useRecoilState(
		isSizeOptionActiveState
	);

	const { canHide16oz, indexSelected } = useMemo(() => {
		let canHide16oz = false;
		let indexSelected = selectedIndex;
		if (selectedItem && PRODUCT_IDS.includes(selectedItem.item.productId)) {
			// logic to hide 16oz
			canHide16oz = true;
			const sizeToBeExcludedIndex = sizes.findIndex(
				size => size.name === SIZE_TO_BE_EXCLUDE
			);

			const kidsSize = sizes.findIndex(
				size =>
					selectedItem.item.productId !== MAGIC_MILK_PRODUCT_ID &&
					KIDS_SIZE.includes(size.name)
			);
			if (sizeToBeExcludedIndex === selectedIndex || kidsSize > -1) {
				if (sizes[selectedIndex + 1]) indexSelected = selectedIndex + 1;
				else if (sizes[selectedIndex - 1])
					indexSelected = selectedIndex - 1;
				if (!modifying) changeSize(indexSelected);
			}
		}
		return { canHide16oz, indexSelected };
	}, [selectedItem, sizes, selectedIndex, modifying, changeSize]);

	const selected: Percomatic.Serialized.Size = sizes[indexSelected] ?? {
		id: 0,
		name: ''
	};

	const body = sizes.map((size, index) => {
		return (canHide16oz && size.name === SIZE_TO_BE_EXCLUDE) ||
			(selectedItem?.item.productId !== MAGIC_MILK_PRODUCT_ID &&
				KIDS_SIZE.includes(size.name)) ? undefined : (
			<div key={size.id}>
				<button
					data-name={normalizeLabel(size.name)} // useful for e2e testing
					className={`product-size-button btn btn-${
						indexSelected === index ? 'primary' : 'white'
					} btn-block ${modifying ? ' modifying' : ''} text-${
						indexSelected === index ? 'white' : 'black'
					}`}
					style={
						indexSelected === index
							? { borderRadius: '4px', color: '#222222' }
							: {
									borderRadius: '4px',
									color: '#222222',
									border: 'solid 2px #b6b6b6'
								}
					}
					onClick={() => {
						if (!modifying) {
							changeSize(index);
						}
					}}
				>
					{size.name}
				</button>
			</div>
		);
	});

	if (body.filter(d => d).length === 0) return null;

	return (
		<div className="product-size">
			<Option
				isActive={isSizeOptionActive}
				header={{
					name: 'sizes',
					left: 'Size',
					right: selected?.name ?? '',
					onClick: () => setIsSizeOptionActive(active => !active)
				}}
			>
				<div className="grid-250-gap-15-p0 product-size-buttons">
					{body}
				</div>
			</Option>
		</div>
	);
};
